import { Component, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-products-dropdown',
  templateUrl: './products-dropdown.component.html',
  styleUrls: ['./products-dropdown.component.scss']
})
export class ProductsDropdownComponent {
  @Input() isDropdownVisible = false;
  
    isClick: boolean = true;
    activeLink: string = '';
    isTitle: string = '';
    private routerSubscription: Subscription = new Subscription();

    constructor(public router: Router) {}

    ngOnInit(): void {
        // Subscribe to route changes
        this.routerSubscription = this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe(() => {
            this.setActiveLinkBasedOnRoute();
          });
    
        // Set the active link on initial load
        //this.setActiveLinkBasedOnRoute();
      }
      
      ngOnDestroy(): void {
        // Unsubscribe to prevent memory leaks
        if (this.routerSubscription) {
          this.routerSubscription.unsubscribe();
        }
      }
      
      setActiveLinkBasedOnRoute(): void {
        const currentUrl = this.router.url;
    
       
          if (currentUrl.includes('ada-access')) {
            this.setActiveLink('aac');
           }
          else if(currentUrl.includes('asset-management')){
             this.setActiveLink('am');
          }
          else if(currentUrl.includes('digital-identity')) {
            this.setActiveLink('dim');
          }
          else if(currentUrl.includes('data-protection')) {
            this.setActiveLink('dp');
          }
          else if(currentUrl.includes('secure-zone')) {
            this.setActiveLink('sz');
          }
          else if(currentUrl.includes('secure-blockchain')) {
            this.setActiveLink('sb');
          }
          else if(currentUrl.includes('insight-egrc')) {
            this.setActiveLink('insightEgrc');
          }
      }
    
      setActiveLink(link: string): void {
        if (this.isClick) {
          this.isDropdownVisible = !this.isDropdownVisible;
        }
        this.activeLink = link;
      }

      aacAuth() { 
        this.router.navigate(['ada-access/auth-tools']);
      }
      
      amAuth() { 
        this.router.navigate(['asset-management/auth-tools']);
      }

      diAuth() { 
        this.router.navigate(['digital-identity/auth-tools']);
      }
      
      dpAuth() { 
        this.router.navigate(['data-protection/auth-tools']);
      }

      szAuth() {
        this.router.navigate(['secure-zone']);
      }

      secureBlockchainAuth() {
        this.router.navigate(['secure-blockchain/auth-tools']);
      }

      insightEgrcAuth() {
        this.router.navigate(['insight-egrc/auth-tools']);
      }
 
  

    openClose() {
      if (this.isClick) {
        this.isDropdownVisible = !this.isDropdownVisible;
      }
    }
}